import { Link } from "@amzn/awsui-components-react";
import { Stage } from "../../../lusca-search-api/generated-src";
import { RedriveKind } from "../redriveKinds";

export interface RedriveItem {
  itemId: string;
  stage: Stage;
  user?: string;
}

export const getColumnDefinitions = (kind: RedriveKind) => [
  {
    id: "itemId",
    header: `${kind.name} ID`,
    width: 350,
    cell: (item: RedriveItem) =>
      kind.itemHref ? (
        <Link href={kind.itemHref(item.itemId, item.stage, item.user)} external>
          {item.itemId}
        </Link>
      ) : (
        item.itemId
      ),
    sortingField: "itemId",
  },
  {
    id: "stage",
    header: "Stage",
    width: 100,
    cell: (item: RedriveItem) => item.stage,
    sortingField: "stage",
  },
];
